// @flow

// DataTable Module
import datatable from '../datatable'

// Constants
export default datatable.DataTable
